import React from 'react'

export function TermsOfSevice() {
    return (
        <div className="row">
            <div className="col-12" id="contact_form_el">
                <div className="row">
                    <div className="col-12 text-left mb-5">
                        <h3 className="header">Terms of Service License Agreement</h3>
                        <h5 className="sub-header padding-top-small">
                            End-User License Agreement for HealthLevel software
                        </h5>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <p>
                            End-User Terms License Agreement ("EULA") is a legal agreement between
                            you (either an individual or a single entity) and HealthLevel Inc., for
                            the HealthLevel software product(s) identified above which may include
                            associated software components, media, printed materials, and "online"
                            or electronic documentation ("HealthLevel"). By installing, copying, or
                            otherwise using the HealthLevel software, you agree to be bound by the
                            terms of this EULA. This license agreement represents the entire
                            agreement concerning the program between you and HealthLevel Inc.,
                            (referred to as "licenser"), and it supersedes any prior proposal,
                            representation, or understanding between the parties. If you do not
                            agree to the terms of this EULA, do not install or use the HealthLevel
                            software.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <p>
                            HealthLevel software is protected by copyright laws and international
                            copyright treaties, as well as other intellectual property laws and
                            treaties. The HealthLevel software is licensed, not sold.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-2">1. Grant of License</h5>
                        <p>
                            HealthLevel Inc. grants you the right to access the web based product
                            evaluation on any compatible browser and computer system.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-3">
                            2. Description of Other Rights and Limitations
                        </h5>
                        <div className="ml-2">
                            <h6 className="strong mb-2">(a) Maintenance of Copyright Notices.</h6>
                            <p className="mb-3">
                                You must not remove or alter any copyright notices on any and all
                                copies of the HealthLevel software.
                            </p>
                            <h6 className="strong mb-2">(b) Distribution.</h6>
                            <p className="mb-3">
                                You may not share user access information or passwords to third
                                parties. Trial registration is versions available from HealthLevel
                                Inc.'s websites and you may invite others to join officially.
                            </p>
                            <h6 className="strong mb-2">
                                (c) Prohibition on Reverse Engineering, Decompilation, and
                                Disassembly.
                            </h6>
                            <p className="mb-3">
                                You may not reverse engineer, decompile, or disassemble the
                                HealthLevel software, except and only to the extent that such
                                activity is expressly permitted by applicable law notwithstanding
                                this limitation.
                            </p>
                            <h6 className="strong mb-2">(d) Rental.</h6>
                            <p className="mb-3">
                                You may not rent, lease, or lend the HealthLevel software.
                            </p>
                            <h6 className="strong mb-2">(e) Support Services.</h6>
                            <p className="mb-3">
                                HealthLevel Inc. may provide you with support services related to
                                the HealthLevel software ("Support Services"). Any supplemental
                                software code provided to you as part of the Support Services shall
                                be considered part of the HealthLevel software and subject to the
                                terms and conditions of this EULA.
                            </p>
                            <h6 className="strong mb-2">(f) Compliance with Applicable Laws.</h6>
                            <p className="mb-3">
                                You must comply with all applicable laws regarding use of the
                                HealthLevel software.
                            </p>
                        </div>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-2">3. Termination</h5>
                        <p>
                            Without prejudice to any other rights, HealthLevel Inc. may terminate
                            this EULA if you fail to comply with the terms and conditions of this
                            EULA. In such event, your access to the website will be terminated.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-2">4. Copyright</h5>
                        <p>
                            All title, including but not limited to copyrights, in and to the
                            HealthLevel software and any copies thereof are owned by HealthLevel
                            Inc. or its suppliers. All title and intellectual property rights in and
                            to the content which may be accessed through use of the HealthLevel
                            software is the property of the respective content owner and may be
                            protected by applicable copyright or other intellectual property laws
                            and treaties. This EULA grants you no rights to use such content. All
                            rights not expressly granted are reserved by HealthLevel Inc.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-2">5. No Warranties</h5>
                        <p>
                            HealthLevel Inc. expressly disclaims any warranty for the HealthLevel
                            software. The HealthLevel software is provided 'As Is' without any
                            express or implied warranty of any kind, including but not limited to
                            any warranties of merchantability, noninfringement, or fitness of a
                            particular purpose. HealthLevel Inc. does not warrant or assume
                            responsibility for the accuracy or completeness of any information,
                            text, graphics, links or other items contained within the HealthLevel
                            software. HealthLevel Inc. makes no warranties respecting any harm that
                            may be caused by the transmission of a computer virus, worm, time bomb,
                            logic bomb, or other such computer program. HealthLevel Inc. further
                            expressly disclaims any warranty or representation to Authorized Users
                            or to any third party.
                        </p>
                    </div>
                    <div className="col-12 text-left mb-4">
                        <h5 className="sub-header-highlight text-left mb-2">
                            6. Limitation of Liability
                        </h5>
                        <p>
                            In no event shall HealthLevel Inc. be liable for any damages (including,
                            without limitation, lost profits, business interruption, or lost
                            information) rising out of 'Authorized Users' use of or inability to use
                            the HealthLevel software, even if HealthLevel Inc. has been advised of
                            the possibility of such damages. In no event will HealthLevel Inc. be
                            liable for loss of data or for indirect, special, incidental,
                            consequential (including lost profit), or other damages based in
                            contract, tort or otherwise. HealthLevel Inc. shall have no liability
                            with respect to the content of the HealthLevel software or any part
                            thereof, including but not limited to errors or omissions contained
                            therein, libel, infringements of rights of publicity, privacy, trademark
                            rights, business interruption, personal injury, loss of privacy, moral
                            rights or the disclosure of confidential information.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}
